//import { HTTP } from '@ionic-native/http/ngx';
import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect} from 'react';
import {triangle} from 'ionicons/icons';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';
import {MerchantOnboarding_Details} from './Modal_MerchantOnboarding';
import {ActiveMerchant_Details} from './Modal_ActiveMerchant';

import '../../css/layout.css';



export function Tab_MerchantList () {

    let zasava_context = useContext(Auth_Zasava_Context);

    let [sessionID, setSessionID ] = useState(zasava_context.sessionID);
    let [baseURL, setBaseURL ] = useState(zasava_context.baseURL);

    let [acctID, setAcctID ] = useState(zasava_context.acctID);
    let [schema, setSchemaName] = useState(zasava_context.schema);
    let [access, setAccessRights] = useState(zasava_context.accessRights);

    let [ViewMerchantList_pending, setViewMerchantList_pending] = useState([]);
    let [ViewMerchantList_approved, setViewMerchantList_approved] = useState([]);

    let [viewManageMerchantModal, setManageMerchantModal] = useState(true);

    let [merchantID, setMerchantID] = useState(null);
    let [merchantSchema, setMerchantSchema] = useState(null);
    let [businessType, setBusinessType] = useState(null);

    let [grid_registrationsPending, setGrid_registrationsPending] = useState(false);
    let [pendingButtonBackground, setPendingButtonBackground] = useState(false);
    let [grid_registrationsApproved, setGrid_registrationsApproved] = useState(true);
    let [approvedButtonBackground, setApprovedButtonBackground] = useState(true);

    let [openMerchantOnboardingModal, setOpenMerchantOnboardingModal] = useState(false);
    let [activeMerchantModal, setActiveMerchantModal] = useState(false);

    //alert('In Business Tabs');

    useEffect(() =>    {

        setViewMerchantList_approved([]);
        setViewMerchantList_pending([]);

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '9004',
                user: zasava_context.acctID,
                sessionID: sessionID,
            })
        }

        
        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);

            let newRow =  res.toString().split('##DATA_2##');

            let rows_data1 = newRow[0].toString().split('~~~');
            let rowss_data2 = newRow[1].toString().split('~~~');

            for (let rownum = 0; rownum < rows_data1.length - 1; ++rownum)
            {
                let cols = rows_data1[rownum].split('|');

                setViewMerchantList_approved((prevViewMerchantList_approved) => {
                    return prevViewMerchantList_approved.concat({
                        merchantID: cols[0],
                        businessType: cols[1],
                        companyName: cols[2],
                        companyPhoneNumber: cols[3],
                        companySchema: cols[4],
                    })
                });

            } 


            for (let rownum = 0; rownum < rowss_data2.length - 1; ++rownum)
            {
                let cols = rowss_data2[rownum].split('|');

                setViewMerchantList_pending((prevViewMerchantList_pending) => {
                    return prevViewMerchantList_pending.concat({
                        merchantID: cols[0],
                        businessType: cols[1],
                        companyName: cols[2],
                        companyPhoneNumber: cols[3],
                        companySchema: cols[4],
                    })
                });

            } 
        })
    }, [])


    function manageMerchantHandler(event){

        //alert("In MANAGE MERCHANT HANDLER");
        //alert(event[0]);
        //alert(event[1]);

        setMerchantID(event[0]);
        setMerchantSchema(event[1]);
        setBusinessType(event[2]);
        setOpenMerchantOnboardingModal(true);

    }


    function manageActiveMerchantHandler(event){

        //alert("In MANAGE MERCHANT HANDLER");
        //alert(event[0]);
        //alert(event[1]);

        setMerchantID(event[0]);
        setMerchantSchema(event[1]);
        setBusinessType(event[2]);
        setActiveMerchantModal(true);

    }


    function handleList_pending(event)
    {
        setGrid_registrationsPending(true);
        setPendingButtonBackground(true);
        setGrid_registrationsApproved(false);
        setApprovedButtonBackground(false);
    }
    function handleList_approved(event)
    {
        setGrid_registrationsPending(false);
        setPendingButtonBackground(false);
        setGrid_registrationsApproved(true);
        setApprovedButtonBackground(true);
    }
   // alert('in Dashboard_Main');

        return (
                <React.Fragment>
                    <IonGrid>
                        <IonRow>
                            <IonCol size='6' className={pendingButtonBackground == true ? 'greenButton' : ''} onClick={() => handleList_pending()}> Pending </IonCol>
                            <IonCol size='6' className={approvedButtonBackground == true ? 'greenButton' : ''} onClick={() => handleList_approved()}> Approved </IonCol>
                        </IonRow>
                    </IonGrid>
           
                    {grid_registrationsPending == true && <IonGrid className='gridText'>
                        <IonRow >
                                <IonCol size='3'> <h4>Mercahnt ID</h4> </IonCol>
                                <IonCol size='3'> <h4>Company Name </h4></IonCol>
                                <IonCol size='3'> <h4>Company Phone Number</h4> </IonCol>
                                <IonCol size='3'> <h4>Action</h4></IonCol>
                        </IonRow>
                        {ViewMerchantList_pending.map((detailData) =>   {
                            return (
                                <IonRow  key={detailData.merchantID}>
                                    <IonCol size='3'><IonText>{detailData.merchantID}</IonText></IonCol>
                                    <IonCol size='3'><IonText>{detailData.companyName}</IonText></IonCol>
                                    <IonCol size='3'><IonText>{detailData.companyPhoneNumber}</IonText></IonCol>
                                    <IonCol size='3'>
                                        <IonButton onClick={() => manageMerchantHandler([detailData.merchantID, detailData.companySchema, detailData.businessType])}> Manage </IonButton>
                                    </IonCol>
                                </IonRow>
                            )
                        }
                        )}
                    </IonGrid> }

                   {grid_registrationsApproved == true && <IonGrid className='gridText'>
                        <IonRow >
                                <IonCol size='3'> <h4>Mercahnt ID</h4> </IonCol>
                                <IonCol size='3'> <h4>Company Name </h4></IonCol>
                                <IonCol size='3'> <h4>Company Phone Number</h4> </IonCol>
                                <IonCol size='3'> <h4>Action</h4></IonCol>
                        </IonRow>
                        {ViewMerchantList_approved.map((detailData) =>   {
                            return (
                                <IonRow  key={detailData.merchantID}>
                                    <IonCol size='3'><IonText>{detailData.merchantID}</IonText></IonCol>
                                    <IonCol size='3'><IonText>{detailData.companyName}</IonText></IonCol>
                                    <IonCol size='3'><IonText>{detailData.companyPhoneNumber}</IonText></IonCol>
                                    <IonCol size='3'>
                                        <IonButton onClick={() => manageActiveMerchantHandler([detailData.merchantID, detailData.companySchema, detailData.businessType])}> Manage </IonButton>
                                    </IonCol>
                                </IonRow>
                            )
                        }
                        )}
                    </IonGrid> }

                    {openMerchantOnboardingModal == true &&  <MerchantOnboarding_Details openModal= { openMerchantOnboardingModal } closeModal={() => setOpenMerchantOnboardingModal(false)} data={{
                        merchantID: merchantID, 
                        merchantSchema: merchantSchema,
                        businessType: businessType
                                            }}></MerchantOnboarding_Details>}


                    {activeMerchantModal == true &&  <ActiveMerchant_Details openModal= { activeMerchantModal } closeModal={() => setActiveMerchantModal(false)} data={{
                        merchantID: merchantID, 
                        merchantSchema: merchantSchema,
                        businessType: businessType
                                            }}></ActiveMerchant_Details>}

                </React.Fragment>
        )
}




